<template>
  <div id="feature-dropdown" v-show="featuresList.length > 1" class="rounded" @mousedown="initResize">
    <div :id="dropdownResizableId" :style="{ width: currentWidth, height: currentHeight }">
      <b-row class="mb-1">
        <b-col id="feature-dropdown-header">
          <h6 class="font-weight-bold">Wybierz obiekt</h6>
        </b-col>
        <b-col md="auto">
          <a href="#" id="feature-dropdown-close" class="float-right text-secondary" @click="closeDropdown"></a>
        </b-col>
      </b-row>
      <div :id="dropdownContentId">
        <b-dropdown-item
          v-for="(feature, index) in featuresList"
          v-bind:key="'feature-' + index"
          @click="openFeature(feature)"
        >
          <span
          >
            {{ feature.properties.display_name || feature.id }}
          </span>
        </b-dropdown-item>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

import {SELECT_FEATURE_DROPDOWN_HIDE, SELECT_FEATURE_FROM_DROPDOWN} from "../store/mutations.type";
import SettingsInstance from "../api/SettingsInstance";

const START_WIDTH = 300;
const START_HEIGHT = 120;

export default {
  name: "FeatureDropdown",
  data: function () {
    return {
      dropdownContentId: "feature-dropdown-content",
      dropdownResizableId: "feature-dropdown-resizable",
      startX: null,
      startY: null,
      startWidth: START_WIDTH,
      width: START_WIDTH,
      minWidth: 120,
      maxWidth: 350,
      startHeight: START_HEIGHT,
      height: START_HEIGHT,
      minHeight: 100,
      maxHeight: 350,
    };
  },
  computed: {
    ...mapGetters([
      "featuresList"
    ]),
    currentWidth() {
      return this.width + "px";
    },
    currentHeight() {
      return this.height + "px";
    }
  },
  mounted() {
    let self = this;
    self.$store.watch(
      () => self.$store.getters.featureDropdownPosition,
      (value, oldValue) => {
        var el = document.getElementById(self.dropdownContentId);
        // el.scrollTop = 0;
        this.width = START_WIDTH;
        this.height = START_HEIGHT;
      }
    );
  },
  methods: {
    closeDropdown() {
      this.$store.commit(SELECT_FEATURE_DROPDOWN_HIDE);
    },
    initResize(e) {
      if (e.target && e.target.id === this.dropdownResizableId) {
        this.startX = e.clientX;
        this.startY = e.clientY;
        this.startWidth = this.width;
        this.startHeight = this.height;
        document.documentElement.addEventListener(
          "mousemove",
          this.resize,
          false
        );
        document.documentElement.addEventListener(
          "mouseup",
          this.stopResize,
          false
        );
      }
    },
    resize(e) {
      e.stopPropagation();
      e.preventDefault();
      let width = this.startWidth + e.clientX - this.startX;
      let height = this.startHeight + e.clientY - this.startY;
      if (width >= this.minWidth && width <= this.maxWidth) {
        this.width = width;
      }
      if (height >= this.minHeight && height <= this.maxHeight) {
        this.height = height;
      }
    },
    stopResize(e) {
      document.documentElement.removeEventListener(
        "mousemove",
        this.resize,
        false
      );
      document.documentElement.removeEventListener(
        "mouseup",
        this.stopResize,
        false
      );
    },
    openFeature(feature) {
      this.$store.dispatch(SELECT_FEATURE_FROM_DROPDOWN, {feature} );
    }
  }
};
</script>
